import axios from 'axios'
import { url_node } from './global'

export const getPdf = async () => {
    let token = sessionStorage.getItem('token')
    let headers = {
        'Content-Type': 'application/json',
        Authorization: token,
    }
    const res = await axios.post(`${url_node}/pdf`, { headers })
    return res
}

export const getPdfComprobanteVenta = async (venta) => {
    let token = sessionStorage.getItem('token')
    let headers = {
        'Content-Type': 'application/json',
        Authorization: token,
    }
    const resource = {
        resource: venta,
    }
    const res = await axios.post(`${url_node}/venta`, resource, { headers })
    return res.data
}

export const getPDFStockActual = async (articulos) => {
    let token = sessionStorage.getItem('token')
    let headers = {
        'Content-Type': 'application/json',
        Authorization: token,
    }
    const resource = {
        resource: articulos,
    }
    const res = await axios.post(`${url_node}/stock`, resource, { headers })
    return res.data
}

export const getPdfReporteHistorialPagosDeCompras = async (pagos) => {
    let token = sessionStorage.getItem('token')
    let headers = {
        'Content-Type': 'application/json',
        Authorization: token,
    }
    const data = {
        resource: {
            pagos,
        },
    }
    const res = await axios.post(`${url_node}/historialPagosDeCompras`, data, {
        headers,
    })
    return res.data
}

export const getPdfPresupuesto = async (presupuesto) => {
    let token = sessionStorage.getItem('token')
    let headers = {
        'Content-Type': 'application/json',
        Authorization: token,
    }
    const data = {
        resource: presupuesto,
    }

    const res = await axios.post(`${url_node}/presupuesto`, data, { headers })
    return res.data
}

export const getPdfHistorialPagosConCC = async (pagos) => {
    let token = sessionStorage.getItem('token')
    let headers = {
        'Content-Type': 'application/json',
        Authorization: token,
    }
    const data = {
        resource: {
            pagos,
        },
    }

    const res = await axios.post(`${url_node}/historialPagosConCC`, data, {
        headers,
    })
    return res.data
}

export const sendPresupuestoPorMail = async ({ presupuesto }, emailData) => {
    let token = sessionStorage.getItem('token')
    let headers = {
        'Content-Type': 'application/json',
        Authorization: token,
    }
    const data = {
        resource: presupuesto,
        emailData: emailData,
    }
    const res = await axios.post(`${url_node}/presupuesto`, data, { headers })
    return res
}

export const articulosExcel = async (articulos, emailData) => {
    let token = sessionStorage.getItem('token')
    let headers = {
        'Content-Type': 'application/json',
        Authorization: token,
    }
    const data = {
        resource: articulos,
        emailData: emailData,
    }
    const res = await axios.post(`${url_node}/articulos`, data, { headers })
    return res
}

export const getExcelReporteVenta = async (
    ventasArticulos,
    ventasTotales,
    ventasMPagos,
    emailData
) => {
    let token = sessionStorage.getItem('token')
    let headers = {
        'Content-Type': 'application/json',
        Authorization: token,
    }
    const data = {
        resource: {
            ventasArticulos,
            ventasTotales,
            ventasMPagos,
        },
        emailData,
    }
    const res = await axios.post(`${url_node}/ventas/reportes`, data, {
        headers,
    })
    return res
}

export const getExcelReporteCompra = async (
    articulos,
    detalle,
    porEstado,
    emailData
) => {
    let token = sessionStorage.getItem('token')
    let headers = {
        'Content-Type': 'application/json',
        Authorization: token,
    }
    const data = {
        resource: {
            articulos,
            detalle,
            porEstado,
        },
        emailData,
    }
    const res = await axios.post(`${url_node}/compras/reportes`, data, {
        headers,
    })
    return res
}

export const getExcelReporteCaja = async (cajas, total, emailData) => {
    let token = sessionStorage.getItem('token')
    let headers = {
        'Content-Type': 'application/json',
        Authorization: token,
    }
    const data = {
        resource: {
            cajas,
            total,
        },
        emailData,
    }
    const res = await axios.post(`${url_node}/cajas/reportes`, data, {
        headers,
    })
    return res
}

export const getExcelReporteCuentaCorriente = async (
    ventasTotalesMedioPago
) => {
    let token = sessionStorage.getItem('token')
    let headers = {
        'Content-Type': 'application/json',
        Authorization: token,
    }
    const data = {
        resource: {
            ventasTotalesMedioPago,
        },
        emailData: null,
    }
    const res = await axios.post(
        `${url_node}/cuenta-corriente/reportes`,
        data,
        { headers }
    )
    return res
}

export const getExcelReporteStockBalance = async (
    periodos,
    filas,
    emailData
) => {
    let token = sessionStorage.getItem('token')
    let headers = {
        'Content-Type': 'application/json',
        Authorization: token,
    }
    const data = {
        resource: {
            periodos,
            filas,
        },
        emailData,
    }
    const res = await axios.post(`${url_node}/stock/balance`, data, {
        headers,
    })
    return res
}

export const getExcelReporteConciliacion = async (filas, umbral, emailData) => {
    let token = sessionStorage.getItem('token')
    let headers = {
        'Content-Type': 'application/json',
        Authorization: token,
    }
    const data = {
        resource: {
            filas,
            umbral,
        },
        emailData,
    }
    const res = await axios.post(`${url_node}/stock/conciliacion`, data, {
        headers,
    })
    return res
}

export const stockExcel = async (stock, emailData) => {
    let token = sessionStorage.getItem('token')
    let headers = {
        'Content-Type': 'application/json',
        Authorization: token,
    }
    const data = {
        resource: stock,
        emailData: emailData,
    }
    const res = await axios.post(`${url_node}/stock/articulos`, data, {
        headers,
    })
    return res
}

// export stock with selected columns:
export const exportStockWithColumns = async (stock, selectedColumns, format) => {
    let token = sessionStorage.getItem('token')
    let headers = {
        'Content-Type': 'application/json',
        Authorization: token,
    }
    const data = {
        resource: stock,
        selectedColumns: selectedColumns,
    }
    const res = await axios.post(`${url_node}/stock/articulos?format=${format}`, data, {
        headers,
    })
    return res
}

export const marcasExcel = async (marcas, emailData) => {
    let token = sessionStorage.getItem('token')
    let headers = {
        'Content-Type': 'application/json',
        Authorization: token,
    }
    const data = {
        resource: marcas,
        emailData: emailData,
    }
    const res = await axios.post(`${url_node}/marcas`, data, { headers })
    return res
}

export const familiasExcel = async (familias, emailData) => {
    let token = sessionStorage.getItem('token')
    let headers = {
        'Content-Type': 'application/json',
        Authorization: token,
    }
    const data = {
        resource: familias,
        emailData: emailData,
    }
    const res = await axios.post(`${url_node}/familias`, data, { headers })
    return res
}

export const departamentosExcel = async (departamentos, emailData) => {
    let token = sessionStorage.getItem('token')
    let headers = {
        'Content-Type': 'application/json',
        Authorization: token,
    }
    const data = {
        resource: departamentos,
        emailData: emailData,
    }
    const res = await axios.post(`${url_node}/depatamentos`, data, { headers })
    return res
}


// export lista precios:
export const listaPreciosExcel = async (listaPrecios, emailData) => {
    let token = sessionStorage.getItem('token')
    let headers = {
        'Content-Type': 'application/json',
        Authorization: token,
    }
    const data = {
        resource: listaPrecios,
        emailData: emailData,
    }
    const res = await axios.post(`${url_node}/articulos-precios`, data, { headers })
    return res
}

// generar código de barra:
export const postCodigoBarra = async (resource) => {
    let token = sessionStorage.getItem('token')
    let headers = {
        'Content-Type': 'application/json',
        Authorization: token,
    }
    const data = { resource }
    const res = await axios.post(`${url_node}/codigo-barra`, data, {
        headers,
    })
    return res
}

// download template:
export const getTemplate = async (templateType) => {
    let token = sessionStorage.getItem('token')
    let headers = {
        'Content-Type': 'application/json',
        Authorization: token,
    }
    const res = await axios.get(`${url_node}/templates/${templateType}`, {
        headers,
    })
    return res
}